<template>
  <div>
    <v-container class="my-7">
      <banner type="top" />

      <v-row>
        <v-col cols="12" md="8" class="mt-6 pr-lg-8">
          <section class="video">
            <article-item type="videos" />
          </section>
        </v-col>

        <v-col md="4" class="mt-6">
          <v-row>
            <v-col cols="12" sm="6" md="12" order="12" order-md="0">
              <banner-video class="mt-4" />
              <!-- <banner type="right-a" class="mt-4" w="100%" h="null" /> -->

              <div class="d-md-none">
                <banner type="right-b" class="mt-4" w="100%" h="null" />
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="12" order="0" order-md="12">
              <most-read class="mt-6" />
            </v-col>
          </v-row>
          <div class="d-none d-md-block">
            <banner type="right-b" class="mt-16" w="100%" h="null" />
          </div>

          <schedule class="mt-12" />
        </v-col>
      </v-row>

      <banner type="center-2" class="mt-12" />
    </v-container>
  </div>
</template>

<script>
import ArticleItem from "@/components/widgets/Article.vue";
import Banner from "@/components/cards/Banner.vue";
import BannerVideo from "@/components/cards/BannerVideo.vue";
import MostRead from "@/components/widgets/MostRead.vue";
import Schedule from "@/components/widgets/Schedule.vue";

export default {
  data: () => ({
    loading: true,
  }),
  components: {
    ArticleItem,
    Banner,
    BannerVideo,
    MostRead,
    Schedule,
  },
};
</script>
